import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2010,
          month: 11,
          day: 26,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 2,
          day: 17,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 4,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 11,
          day: 21,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 3,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 2,
          day: 10,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 10,
          day: 5,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 6,
          day: 7,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 1,
          day: 4,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 3,
          day: 6,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 6,
          day: 11,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 9,
          day: 8,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 18,
        },
      },
      {
        color: 'green',
        date: {
          year: 2019,
          month: 2,
          day: 18,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 1,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 4,
          day: 18,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2010,
          month: 11,
          day: 26,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 2,
          day: 17,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 4,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 11,
          day: 21,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 3,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 2,
          day: 10,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 10,
          day: 5,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 6,
          day: 7,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 1,
          day: 4,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 3,
          day: 6,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 6,
          day: 11,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 9,
          day: 8,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 18,
        },
      },
      {
        color: 'green',
        date: {
          year: 2019,
          month: 2,
          day: 18,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 1,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 4,
          day: 18,
        },
      },
    ],
  },
};
